import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/relatorio-vendas')({
  component: lazyRouteComponent(
    () => import('@/features/relatorios/components/relatorio-vendas-page'),
    'RelatorioVendasPage'
  ),
})
